'use strict';

const currentDomain = window.location.origin;

var allowedLanguages = ['de', 'en', 'fr', 'es', 'it'];
var allowedCountries = [
  'DE',
  'FR',
  'ES',
  'BE',
  'LU',
  'AT',
  'GB',
  'DK',
  'SE',
  'FI',
  'NL',
  'IT'
];

var countryOptions = {
  de: {
    zoom: 6,
    lat: 50.9767768,
    lng: 9.7421417
    // disableSearchDetails: false,
    // disableLuggage: true,
    // disableBoxes: true,
    // disableTime: true
  },
  fr: {
    disableSearchDetails: true,
    zoom: 6,
    lat: 46.8023388,
    lng: 1.6551867
  },
  es: {
    disableSearchDetails: true,
    zoom: 6,
    lat: 40.0177429,
    lng: -3.1328886
  },
  be: {
    disableSearchDetails: true,
    zoom: 7,
    lat: 50.5893679,
    lng: 4.2557155
  },
  lu: {
    disableSearchDetails: true,
    zoom: 9,
    lat: 49.8048577,
    lng: 6.080911
  },
  at: {
    disableLuggage: true,
    zoom: 7,
    lat: 47.5759594,
    lng: 13.7265485
  },
  gb: {
    disableSearchDetails: true,
    zoom: 6,
    lat: 53.7531024,
    lng: -3.7908417
  },
  dk: {
    disableSearchDetails: true,
    zoom: 7,
    lat: 56.2388551,
    lng: 10.3602386
  },
  se: {
    disableSearchDetails: true,
    zoom: 6,
    lat: 57.7560511,
    lng: 14.0478284
  },
  fi: {
    disableSearchDetails: true,
    zoom: 6,
    lat: 61.8260563,
    lng: 25.4429177
  },
  nl: {
    disableSearchDetails: true,
    zoom: 7,
    lat: 52.2316558,
    lng: 5.0903367
  },
  it: {
    disableSearchDetails: true,
    zoom: 7,
    lat: 42.6384261,
    lng: 12.674297
  }
};

const apiKey = {
  urlQuery: 'r',
  value: '763595e1-f6e4-4'
};
const query = window.location.search.substring(1);
const vars = query.split('&');
let i;
for (i = 0; i < vars.length; ++i) {
  var pair = vars[i].split('=');
  if (pair[0] == apiKey.urlQuery) {
    apiKey.value = pair[1];
  }
}

const env = process.env.REACT_WEBPACK_ENV;
const psfLocationEndpoint = `${currentDomain}/psfinder-api/findParcelShopByLocation/`;
const psfDetailEndpoint = `${currentDomain}/psfinder-api/parcelshop/`;
const psfImageEndpoint = `${currentDomain}/psfinder-api/parcelshopImage/`;

// Settings configured here will be merged into the final config object.
export default {
  allowedCountries, allowedLanguages, countryOptions, apiKey, env, psfLocationEndpoint, psfDetailEndpoint, psfImageEndpoint
}
